"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChatMessageInput = require("./ChatMessageInput");
Object.keys(_ChatMessageInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatMessageInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatMessageInput[key];
    }
  });
});